import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "wvh0d9r";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const Content = ({
  membershipsCount,
  eventTypeName,
  groupsCount
}) => {
  if (membershipsCount === 0 && groupsCount === 0) {
    return <BodyText>
        {I18n.t('publisher.organization.managed_event_types.delete_popup.no_memberships')}
      </BodyText>;
  }
  return <Wrapper>
      <BodyText>
        {I18n.t('publisher.organization.managed_event_types.delete_popup.line_1', {
        eventTypeName
      })}
      </BodyText>
      <BodyText>
        {I18n.t('publisher.organization.managed_event_types.delete_popup.line_2')}
      </BodyText>
      <BodyText>
        {I18n.t('publisher.organization.managed_event_types.delete_popup.change_permanent')}
      </BodyText>
    </Wrapper>;
};
export const DestroyPopup = ({
  eventTypeName,
  membershipsCount,
  groupsCount,
  isOpen,
  onClose,
  onDestroy,
  isDestroyProgress
}) => <SimplePopup isOpen={isOpen} isDestructive onClose={onClose} title={I18n.t('publisher.organization.managed_event_types.delete_popup.title', {
  eventTypeName
})} cancelLabel={I18n.t('publisher.action.cancel')} confirmLabel={I18n.t('publisher.action.delete')} onConfirm={onDestroy} isLoading={isDestroyProgress}>
    <Content membershipsCount={membershipsCount} groupsCount={groupsCount} eventTypeName={eventTypeName} />
  </SimplePopup>;

require("./destroy_popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./destroy_popup.js");